import { createAction } from '@reduxjs/toolkit';

import { AccommodationItemModel, LocationDetailsModel } from '@app/models';

/**
 * Set selected accommodation
 */
export const setSelectedAccommodationAction = createAction<{
    accommodation: AccommodationItemModel | null;
}>('map-search/setSelectedAccommodation');

/**
 * Set location details
 */
export const setLocationDetailsAction = createAction<{
    locationDetails: LocationDetailsModel | null;
}>('map-search/setLocationDetails');

/**
 * Set map loaded
 */
export const setIsMapLoadedAction = createAction<{
    isMapLoaded: boolean;
}>('map-search/setIsMapLoaded');
